import buildType12pxIcon from '@jetbrains/icons/buildType-12px.svg?react'
import buildType20pxIcon from '@jetbrains/icons/buildType-20px.svg?react'
import buildTypeCancelIcon from '@jetbrains/icons/buildType-cancel.svg?react'
import buildTypeComposite12pxIcon from '@jetbrains/icons/buildType-composite-12px.svg?react'
import buildTypeComposite20pxIcon from '@jetbrains/icons/buildType-composite-20px.svg?react'
import buildTypeCompositeCancelIcon from '@jetbrains/icons/buildType-composite-cancel.svg?react'
import buildTypeCompositeEdit12pxIcon from '@jetbrains/icons/buildType-composite-edit-12px.svg?react'
import buildTypeCompositeEdit20pxIcon from '@jetbrains/icons/buildType-composite-edit-20px.svg?react'
import buildTypeCompositeEditIcon from '@jetbrains/icons/buildType-composite-edit.svg?react'
import buildTypeCompositeError12pxIcon from '@jetbrains/icons/buildType-composite-error-12px.svg?react'
import buildTypeCompositeError20pxIcon from '@jetbrains/icons/buildType-composite-error-20px.svg?react'
import buildTypeCompositeErrorPaused12pxIcon from '@jetbrains/icons/buildType-composite-error-paused-12px.svg?react'
import buildTypeCompositeErrorPaused20pxIcon from '@jetbrains/icons/buildType-composite-error-paused-20px.svg?react'
import buildTypeCompositeErrorPausedIcon from '@jetbrains/icons/buildType-composite-error-paused.svg?react'
import buildTypeCompositeErrorIcon from '@jetbrains/icons/buildType-composite-error.svg?react'
import buildTypeCompositeHourglassIcon from '@jetbrains/icons/buildType-composite-hourglass.svg?react'
import buildTypeCompositeLocked12pxIcon from '@jetbrains/icons/buildType-composite-locked-12px.svg?react'
import buildTypeCompositeLocked20pxIcon from '@jetbrains/icons/buildType-composite-locked-20px.svg?react'
import buildTypeCompositeLockedIcon from '@jetbrains/icons/buildType-composite-locked.svg?react'
import buildTypeCompositePaused12pxIcon from '@jetbrains/icons/buildType-composite-paused-12px.svg?react'
import buildTypeCompositePaused20pxIcon from '@jetbrains/icons/buildType-composite-paused-20px.svg?react'
import buildTypeCompositePausedIcon from '@jetbrains/icons/buildType-composite-paused.svg?react'
import buildTypeCompositeRunIcon from '@jetbrains/icons/buildType-composite-run.svg?react'
import buildTypeCompositeSpinnerIcon from '@jetbrains/icons/buildType-composite-spinner.svg?react'
import buildTypeCompositeWarning12pxIcon from '@jetbrains/icons/buildType-composite-warning-12px.svg?react'
import buildTypeCompositeWarning20pxIcon from '@jetbrains/icons/buildType-composite-warning-20px.svg?react'
import buildTypeCompositeWarningIcon from '@jetbrains/icons/buildType-composite-warning.svg?react'
import buildTypeCompositeIcon from '@jetbrains/icons/buildType-composite.svg?react'
import buildTypeEdit12pxIcon from '@jetbrains/icons/buildType-edit-12px.svg?react'
import buildTypeEdit20pxIcon from '@jetbrains/icons/buildType-edit-20px.svg?react'
import buildTypeEditIcon from '@jetbrains/icons/buildType-edit.svg?react'
import buildTypeError12pxIcon from '@jetbrains/icons/buildType-error-12px.svg?react'
import buildTypeError20pxIcon from '@jetbrains/icons/buildType-error-20px.svg?react'
import buildTypeErrorPaused12pxIcon from '@jetbrains/icons/buildType-error-paused-12px.svg?react'
import buildTypeErrorPaused20pxIcon from '@jetbrains/icons/buildType-error-paused-20px.svg?react'
import buildTypeErrorPausedIcon from '@jetbrains/icons/buildType-error-paused.svg?react'
import buildTypeErrorIcon from '@jetbrains/icons/buildType-error.svg?react'
import buildTypeHourglassIcon from '@jetbrains/icons/buildType-hourglass.svg?react'
import buildTypeLocked12pxIcon from '@jetbrains/icons/buildType-locked-12px.svg?react'
import buildTypeLocked20pxIcon from '@jetbrains/icons/buildType-locked-20px.svg?react'
import buildTypeLockedIcon from '@jetbrains/icons/buildType-locked.svg?react'
import buildTypePaused12pxIcon from '@jetbrains/icons/buildType-paused-12px.svg?react'
import buildTypePaused20pxIcon from '@jetbrains/icons/buildType-paused-20px.svg?react'
import buildTypePausedIcon from '@jetbrains/icons/buildType-paused.svg?react'
import buildTypeRunIcon from '@jetbrains/icons/buildType-run.svg?react'
import buildTypeSpinnerIcon from '@jetbrains/icons/buildType-spinner.svg?react'
import buildTypeWarning12pxIcon from '@jetbrains/icons/buildType-warning-12px.svg?react'
import buildTypeWarning20pxIcon from '@jetbrains/icons/buildType-warning-20px.svg?react'
import buildTypeWarningIcon from '@jetbrains/icons/buildType-warning.svg?react'
import buildTypeIcon from '@jetbrains/icons/buildType.svg?react'
import investigation12pxIcon from '@jetbrains/icons/investigation-12px.svg?react'
import investigation20pxIcon from '@jetbrains/icons/investigation-20px.svg?react'
import investigationIcon from '@jetbrains/icons/investigation.svg?react'
import pipeline12pxIcon from '@jetbrains/icons/pipeline-12px.svg?react'
import pipeline20pxIcon from '@jetbrains/icons/pipeline-20px.svg?react'
import pipelineCancelIcon from '@jetbrains/icons/pipeline-cancel.svg?react'
import pipelineEdit12pxIcon from '@jetbrains/icons/pipeline-edit-12px.svg?react'
import pipelineEdit20pxIcon from '@jetbrains/icons/pipeline-edit-20px.svg?react'
import pipelineEditIcon from '@jetbrains/icons/pipeline-edit.svg?react'
import pipelineError12pxIcon from '@jetbrains/icons/pipeline-error-12px.svg?react'
import pipelineError20pxIcon from '@jetbrains/icons/pipeline-error-20px.svg?react'
import pipelineErrorPaused12pxIcon from '@jetbrains/icons/pipeline-error-paused-12px.svg?react'
import pipelineErrorPaused20pxIcon from '@jetbrains/icons/pipeline-error-paused-20px.svg?react'
import pipelineErrorPausedIcon from '@jetbrains/icons/pipeline-error-paused.svg?react'
import pipelineErrorIcon from '@jetbrains/icons/pipeline-error.svg?react'
import pipelineHourglassIcon from '@jetbrains/icons/pipeline-hourglass.svg?react'
import pipelineLocked12pxIcon from '@jetbrains/icons/pipeline-locked-12px.svg?react'
import pipelineLocked20pxIcon from '@jetbrains/icons/pipeline-locked-20px.svg?react'
import pipelineLockedIcon from '@jetbrains/icons/pipeline-locked.svg?react'
import pipelinePaused12pxIcon from '@jetbrains/icons/pipeline-paused-12px.svg?react'
import pipelinePaused20pxIcon from '@jetbrains/icons/pipeline-paused-20px.svg?react'
import pipelinePausedIcon from '@jetbrains/icons/pipeline-paused.svg?react'
import pipelineRunIcon from '@jetbrains/icons/pipeline-run.svg?react'
import pipelineSpinnerIcon from '@jetbrains/icons/pipeline-spinner.svg?react'
import pipelineWarning12pxIcon from '@jetbrains/icons/pipeline-warning-12px.svg?react'
import pipelineWarning20pxIcon from '@jetbrains/icons/pipeline-warning-20px.svg?react'
import pipelineWarningIcon from '@jetbrains/icons/pipeline-warning.svg?react'
import pipelineIcon from '@jetbrains/icons/pipeline.svg?react'
import project12pxIcon from '@jetbrains/icons/project-12px.svg?react'
import project20pxIcon from '@jetbrains/icons/project-20px.svg?react'
import projectEdit12pxIcon from '@jetbrains/icons/project-edit-12px.svg?react'
import projectEdit20pxIcon from '@jetbrains/icons/project-edit-20px.svg?react'
import projectEditIcon from '@jetbrains/icons/project-edit.svg?react'
import projectError12pxIcon from '@jetbrains/icons/project-error-12px.svg?react'
import projectError20pxIcon from '@jetbrains/icons/project-error-20px.svg?react'
import projectErrorIcon from '@jetbrains/icons/project-error.svg?react'
import projectLocked12pxIcon from '@jetbrains/icons/project-locked-12px.svg?react'
import projectLocked20pxIcon from '@jetbrains/icons/project-locked-20px.svg?react'
import projectLockedIcon from '@jetbrains/icons/project-locked.svg?react'
import projectIcon from '@jetbrains/icons/project.svg?react'
import template12pxIcon from '@jetbrains/icons/template-12px.svg?react'
import template20pxIcon from '@jetbrains/icons/template-20px.svg?react'
import templateEdit12pxIcon from '@jetbrains/icons/template-edit-12px.svg?react'
import templateEdit20pxIcon from '@jetbrains/icons/template-edit-20px.svg?react'
import templateEditIcon from '@jetbrains/icons/template-edit.svg?react'
import templateIcon from '@jetbrains/icons/template.svg?react'
import type {IconType as Icon} from '@jetbrains/ring-ui-built/components/icon/icon'
import {SvgIcon} from '@jetbrains/teamcity-ui/dist/components'
import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'
import classNames from 'classnames'
import * as React from 'react'

import {BuildStatusType} from '../../../types'

import type {DefaultProps, Props} from './ProjectOrBuildTypeIcon.types'
import {EntityIconType, Sizes} from './ProjectOrBuildTypeIcon.types'

import styles from './ProjectOrBuildTypeIcon.module.css'

const Icons: KeyValue<string, Icon> = {
  buildType: buildTypeIcon,
  'buildType-12px': buildType12pxIcon,
  'buildType-20px': buildType20pxIcon,
  'buildType-cancel': buildTypeCancelIcon,
  'buildType-composite': buildTypeCompositeIcon,
  'buildType-composite-12px': buildTypeComposite12pxIcon,
  'buildType-composite-20px': buildTypeComposite20pxIcon,
  'buildType-composite-cancel': buildTypeCompositeCancelIcon,
  'buildType-composite-edit': buildTypeCompositeEditIcon,
  'buildType-composite-edit-12px': buildTypeCompositeEdit12pxIcon,
  'buildType-composite-edit-20px': buildTypeCompositeEdit20pxIcon,
  'buildType-composite-error': buildTypeCompositeErrorIcon,
  'buildType-composite-error-12px': buildTypeCompositeError12pxIcon,
  'buildType-composite-error-20px': buildTypeCompositeError20pxIcon,
  'buildType-composite-error-paused': buildTypeCompositeErrorPausedIcon,
  'buildType-composite-error-paused-12px': buildTypeCompositeErrorPaused12pxIcon,
  'buildType-composite-error-paused-20px': buildTypeCompositeErrorPaused20pxIcon,
  'buildType-composite-hourglass': buildTypeCompositeHourglassIcon,
  'buildType-composite-locked': buildTypeCompositeLockedIcon,
  'buildType-composite-locked-12px': buildTypeCompositeLocked12pxIcon,
  'buildType-composite-locked-20px': buildTypeCompositeLocked20pxIcon,
  'buildType-composite-paused': buildTypeCompositePausedIcon,
  'buildType-composite-paused-12px': buildTypeCompositePaused12pxIcon,
  'buildType-composite-paused-20px': buildTypeCompositePaused20pxIcon,
  'buildType-composite-run': buildTypeCompositeRunIcon,
  'buildType-composite-spinner': buildTypeCompositeSpinnerIcon,
  'buildType-composite-warning': buildTypeCompositeWarningIcon,
  'buildType-composite-warning-12px': buildTypeCompositeWarning12pxIcon,
  'buildType-composite-warning-20px': buildTypeCompositeWarning20pxIcon,
  'buildType-edit': buildTypeEditIcon,
  'buildType-edit-12px': buildTypeEdit12pxIcon,
  'buildType-edit-20px': buildTypeEdit20pxIcon,
  'buildType-error': buildTypeErrorIcon,
  'buildType-error-12px': buildTypeError12pxIcon,
  'buildType-error-20px': buildTypeError20pxIcon,
  'buildType-error-paused': buildTypeErrorPausedIcon,
  'buildType-error-paused-12px': buildTypeErrorPaused12pxIcon,
  'buildType-error-paused-20px': buildTypeErrorPaused20pxIcon,
  'buildType-hourglass': buildTypeHourglassIcon,
  'buildType-locked': buildTypeLockedIcon,
  'buildType-locked-12px': buildTypeLocked12pxIcon,
  'buildType-locked-20px': buildTypeLocked20pxIcon,
  'buildType-paused': buildTypePausedIcon,
  'buildType-paused-12px': buildTypePaused12pxIcon,
  'buildType-paused-20px': buildTypePaused20pxIcon,
  'buildType-run': buildTypeRunIcon,
  'buildType-spinner': buildTypeSpinnerIcon,
  'buildType-warning': buildTypeWarningIcon,
  'buildType-warning-12px': buildTypeWarning12pxIcon,
  'buildType-warning-20px': buildTypeWarning20pxIcon,
  investigation: investigationIcon,
  'investigation-12px': investigation12pxIcon,
  'investigation-20px': investigation20pxIcon,
  pipeline: pipelineIcon,
  'pipeline-12px': pipeline12pxIcon,
  'pipeline-20px': pipeline20pxIcon,
  'pipeline-cancel': pipelineCancelIcon,
  'pipeline-edit': pipelineEditIcon,
  'pipeline-edit-12px': pipelineEdit12pxIcon,
  'pipeline-edit-20px': pipelineEdit20pxIcon,
  'pipeline-error': pipelineErrorIcon,
  'pipeline-error-12px': pipelineError12pxIcon,
  'pipeline-error-20px': pipelineError20pxIcon,
  'pipeline-error-paused': pipelineErrorPausedIcon,
  'pipeline-error-paused-12px': pipelineErrorPaused12pxIcon,
  'pipeline-error-paused-20px': pipelineErrorPaused20pxIcon,
  'pipeline-hourglass': pipelineHourglassIcon,
  'pipeline-locked': pipelineLockedIcon,
  'pipeline-locked-12px': pipelineLocked12pxIcon,
  'pipeline-locked-20px': pipelineLocked20pxIcon,
  'pipeline-paused': pipelinePausedIcon,
  'pipeline-paused-12px': pipelinePaused12pxIcon,
  'pipeline-paused-20px': pipelinePaused20pxIcon,
  'pipeline-run': pipelineRunIcon,
  'pipeline-spinner': pipelineSpinnerIcon,
  'pipeline-warning': pipelineWarningIcon,
  'pipeline-warning-12px': pipelineWarning12pxIcon,
  'pipeline-warning-20px': pipelineWarning20pxIcon,
  project: projectIcon,
  'project-12px': project12pxIcon,
  'project-20px': project20pxIcon,
  'project-edit': projectEditIcon,
  'project-edit-12px': projectEdit12pxIcon,
  'project-edit-20px': projectEdit20pxIcon,
  'project-error': projectErrorIcon,
  'project-error-12px': projectError12pxIcon,
  'project-error-20px': projectError20pxIcon,
  'project-locked': projectLockedIcon,
  'project-locked-12px': projectLocked12pxIcon,
  'project-locked-20px': projectLocked20pxIcon,
  template: templateIcon,
  'template-12px': template12pxIcon,
  'template-20px': template20pxIcon,
  'template-edit': templateEditIcon,
  'template-edit-12px': templateEdit12pxIcon,
  'template-edit-20px': templateEdit20pxIcon,
}

const warnedNames = new Set<string>()
const getIcon = (name: string, fallback: Icon): Icon => {
  const icon = Icons[name]
  if (icon == null) {
    if (process.env.NODE_ENV !== 'production' && !warnedNames.has(name)) {
      warnedNames.add(name)
      // eslint-disable-next-line no-console
      console.error(`[ProjectOrBuildTypeIcon] no static icon registered for "${name}"`)
    }
    return fallback
  }
  return icon
}

const primaryTypes = new Set<EntityIconType>([
  EntityIconType.PROJECT,
  EntityIconType.BUILD_TYPE,
  EntityIconType.PIPELINE,
])

class ProjectOrBuildTypeIcon extends React.PureComponent<Props> {
  static defaultProps: DefaultProps = {
    type: EntityIconType.PROJECT,
    size: 'M',
  }

  render(): React.ReactNode {
    const {
      type,
      composite,
      status,
      size,
      className,
      title,
      paused,
      edit,
      locked,
      running,
      failedToStart,
    } = this.props

    if (type == null) {
      return null
    }

    const failed = status === BuildStatusType.FAILURE || status === 'failed'
    const canceled = status === BuildStatusType.CANCELED
    const queued = status === BuildStatusType.QUEUED

    const typeIsInvestigation = type === EntityIconType.INVESTIGATION
    const typeIsPrimary = primaryTypes.has(type)
    const typeIsRunnable = type === EntityIconType.BUILD_TYPE || type === EntityIconType.PIPELINE
    const showPaused = paused && !typeIsInvestigation && !locked

    const classes = classNames(
      styles.icon,
      className,
      (typeIsPrimary || typeIsInvestigation) && status && styles[status],
      {
        [styles.iconL]: size === 'L',
        [styles.paused]: showPaused,
        [styles.edit]: edit,
        [styles.locked]: locked,
        [styles.running]: running,
      },
    )
    const sizeSuffix = size === 'M' ? '' : `-${Sizes[size]}px`
    const name = [
      type,
      type === 'buildType' && composite === true && 'composite',
      typeIsRunnable && running && 'spinner',
      typeIsPrimary && !running && failed && !failedToStart && 'error',
      typeIsPrimary && !running && failed && failedToStart && 'warning',
      typeIsRunnable && !running && canceled && 'cancel',
      typeIsRunnable && !running && queued && 'hourglass',
      showPaused && 'paused',
      edit && 'edit',
      locked && 'locked',
      size === 'M' ? null : `${Sizes[size]}px`,
    ]
      .filter(Boolean)
      .join('-')
    const fallbackIcon = Icons[`${type}${sizeSuffix}`] ?? Icons[type] ?? projectIcon
    return <SvgIcon className={classes} icon={getIcon(name, fallbackIcon)} title={title} />
  }
}

export default ProjectOrBuildTypeIcon
